import { IAdvertisingBlock } from '@/interfaces/advertisingBlock.interface';
import { FC } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import { getTruncatedTxt, hideImgOnError } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL, PARTNER_BOOKS_LFROM, otherAuthorsBooksSliderConfig } from '@/helpers/variables';
import styles from './HomeAdvertisingSlider.module.scss';

interface IHomeAdvertisingSlider {
  books: IAdvertisingBlock;
}

const HomeAdvertisingSlider: FC<IHomeAdvertisingSlider> = ({ books }) => {
  const sortBooksData = (arr: IAdvertisingBlock) =>
    arr.sort((a, b) => {
      return a.position - b.position;
    });

  return (
    <>
      <div className="contentHeader">
        <div className="contentHeader__item">
          <b>Лучшие книги нашего партнера</b>
        </div>
      </div>
      <div className="content">
        <div className={styles.advertSlider} id="__booksSlider">
          <Slider {...otherAuthorsBooksSliderConfig}>
            {sortBooksData(books).map((item) => {
              const bookAlias = `${item.litres_url}?lfrom=${PARTNER_BOOKS_LFROM}`;

              return (
                <div key={item.id} className={styles.advertSlider__item}>
                  <div className={styles.advertSlider__itemImgWrap}>
                    <Link prefetch={false} target="_blank" href={bookAlias} className={styles.advertSlider__itemImg}>
                      <img className={styles.advertSlider__img} src={`${DEV_ABSOLUTE_URL}/covers/${item.external_id}.jpg`} alt="img" onError={hideImgOnError} width="130" height="194" />
                    </Link>
                  </div>
                  <Link prefetch={false} target="_blank" href={bookAlias} className={styles.advertSlider__itemTitle}>
                    {getTruncatedTxt(item.title, 50)}
                  </Link>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};
export default HomeAdvertisingSlider;
